import React, {useEffect} from 'react';
import {Pressable} from 'react-native';
import {View} from 'react-native';
import RNModal from 'react-native-modal';
import {faCircleXmark} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';

import Text from '../../themed/Text';
import AddToWallet from '../AddToWallet';
import InStoreCode from '../InStoreCode';
import MemberCard from '../MemberCard';

import {ViewMyCardCTA} from './ViewMyCardCTA';

type ViewMyCardProps = {
  inStoreCode: string;
  walletUrl: string;
  cardNumber: string;
  name: string;
  mode?: 'print' | 'screen';
};

/**
 * This component shows a CTA and when clicked opens the rewards card modal
 */
export default function ViewMyCard({
  inStoreCode,
  walletUrl,
  cardNumber,
  name,
  mode = 'screen',
}: ViewMyCardProps) {
  const [visible, setVisible] = React.useState(false);
  const [isModalShown, setIsModalShown] = React.useState(false);

  useEffect(() => {
    if (mode === 'print' && isModalShown) {
      window.onafterprint = () => {
        setVisible(false);
      };

      // Trigger browser print
      window.print(); 

      return () => {
        window.onafterprint = null;
      };
    }
  }, [mode, isModalShown]);

  const memberCard = (
    <MemberCard cardNumber={cardNumber} name={name}>
    {({color}) => (
      <View nativeID='in-store-code-container'>
        <View style={{maxHeight: 60, flexGrow: 1, flexBasis: 40}} />
        <Text color={color} variant="body2">
          {mode === 'screen' ? 'Want to keep a hold of your phone?' : 'Barcode not working?'} Give this code at checkout
          instead.
        </Text>
          <InStoreCode color={color} inStoreCode={inStoreCode} />
      </View>
      )}
    </MemberCard>
  );

  return (
    <>
      {mode === 'print' && <style>{printStyles}</style>}
      <ViewMyCardCTA
        onPress={() => {
          setVisible(true);
        }}
        mode={mode}
      />
      <RNModal
        isVisible={visible}
        hasBackdrop
        backdropColor="white"
        backdropOpacity={mode === 'print' ? 1 : 0.75}
        onBackdropPress={() => setVisible(false)}
        onBackButtonPress={() => setVisible(false)}
        onModalShow={() => setIsModalShown(true)}
        onModalHide={() => setIsModalShown(false)}
        style={{
          gap: 20,
          alignItems: 'center',
        }}>

        {mode === 'print' ? (
          <View nativeID='print-container'>
            {memberCard}
          </View>
        ) : (
          memberCard
        )}

        <AddToWallet walletUrl={walletUrl} />

        <Pressable style={{marginTop: 16}} onPress={() => setVisible(false)}>
          <FontAwesomeIcon
            icon={faCircleXmark}
            color="white"
            //   secondaryColor="white"
            style={{alignSelf: 'center'}}
            size={40}
          />
        </Pressable>
      </RNModal>
    </>
  );
}

const printStyles = `
@media print {
  /* Disable scrolling so print isn't multi-page */
  #root {
    overflow: hidden !important;
  }
  /* Ensure card branding is printed */
  #print-container {
    -webkit-print-color-adjust: exact !important;   /* Chrome, Safari 6 – 15.3, Edge */
    color-adjust: exact !important;                 /* Firefox 48 – 96 */
    print-color-adjust: exact !important;           /* Firefox 97+, Safari 15.4+ */
  }
  /* In-Store code changes every 10mins so hide printing */
  #in-store-code-container {
    display: none !important;
  }
}
`;